import Vue from 'vue';
import {
  CONFIGURATOR_PRODUCT,
  CONFIGURATOR_ADD_ITEM,
  CONFIGURATOR_CHANGED_ITEM,
  CONFIGURATOR_REMOVE_ITEM,
  CONFIGURATOR_UPDATE_QUANTITY,
  CONFIGURATOR_CLEAR_CHANGED_ITEM,
  CONFIGURATOR_CLEAR,
  SHOW_HELP,
  HIDE_HELP,
  CONFIGURATOR_SET_ORDER_ITEM_UPDATE,
  CONFIGURATOR_CLEAR_BUNDLE,
} from './types';

// TODO: Replace name keys to ids
export default {
  /**
   * Setup product for configuration.
   * @param state
   * @param productKey
   * @param orderItemId
   * @param orderItem
   */
  [CONFIGURATOR_PRODUCT]: (state, {
    productKey,
    orderItemId,
    orderItem = {},
  }) => {
    state.product = productKey;
    state.orderItemId = orderItemId;
    state.orderItem = orderItem;
  },
  /**
   * Add item to configured order.
   */
  [CONFIGURATOR_ADD_ITEM]: (state, categoryChange) => {
    const { object, key, value } = categoryChange;

    Vue.set(object, key, value);
  },
  /**
   * Remove item to configured order.
   */
  [CONFIGURATOR_REMOVE_ITEM]: (state, categoryChange) => {
    const { object, key } = categoryChange;

    Vue.delete(object, key);
  },
  /**
   * Set the last changed item.
   */
  [CONFIGURATOR_CHANGED_ITEM]: (state, item) => {
    state.changedItem = item;
  },
  [CONFIGURATOR_UPDATE_QUANTITY]: (state, quantity) => {
    state.quantity = quantity;
  },
  [CONFIGURATOR_SET_ORDER_ITEM_UPDATE]: (state) => {
    state.orderItemWatcher = !state.orderItemWatcher;
  },
  [CONFIGURATOR_CLEAR]: (state) => {
    state.orderItem = {};
    state.orderItemId = null;
  },

  /**
   * Clear changed item.
   */
  [CONFIGURATOR_CLEAR_CHANGED_ITEM]: (state) => {
    state.changedItem = null;
  },

  /**
   * Show help message.
   */
  [SHOW_HELP]: (state) => {
    state.showHelp = true;
  },

  /**
   * Hide help message.
   */
  [HIDE_HELP]: (state) => {
    state.showHelp = false;
  },

  /**
   * Clear configurator bundle.
   * @param state
   * @param {number} bundleId
   */
  [CONFIGURATOR_CLEAR_BUNDLE]: (state, { bundleId }) => {
    const { orderItem } = state;

    Object.keys(orderItem).forEach((categoryKey) => {
      const productCategory = orderItem[categoryKey];

      Object.keys(productCategory).forEach((productKey) => {
        const product = productCategory[productKey];

        if (product.bundleId === bundleId) {
          Vue.delete(productCategory, productKey);
        }
      });
    });
  },
};



// WEBPACK FOOTER //
// ./src/apps/configurator/store/mutations.js